import * as React from "react";

export function OffsetText(props: OffsetTextProps): JSX.Element {
    return <div style={{ marginLeft: "30px" }}>{props.text}</div>;
}

export interface OffsetTextProps {
    text: string;
}
